import React, { Component } from 'react'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import API from 'lib/api'
import Loader from 'components/Loader'
import ReDeliveryForm from './ReDeliveryForm'
import { getMessage } from 'lib/translator'
import '../style.scss'

class ReDeliveryPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      saleOrderData: null,
      loading: true,
      failed: false,
    }
    this.getSaleOrder = this.getSaleOrder.bind(this)
  }

  componentDidMount() {
    this.getSaleOrder()
  }

  componentWillUnmount() {
    this.getSaleOrderApi && this.getSaleOrderApi.cancel()
  }

  async getSaleOrder() {
    this.setState({ loading: true, failed: false })
    const referenceNumber = this.props.match?.params?.id
    this.getSaleOrderApi = new API({
      url: `/order-service/v3/salesOrders/${referenceNumber}`,
    })
    this.getSaleOrderApi.get().then(
      (response) => {
        this.setState({ saleOrderData: response.salesOrder, loading: false })
      },
      (error) => {
        this.setState({ failed: true, loading: false })
        if (error.code === 401) {
          throw error
        }
      }
    )
  }

  render() {
    const { saleOrderData, loading, failed } = this.state
    const referenceNumber = this.props.match?.params?.id
    const action = this.props.match?.params?.action

    return (
      <AuthenticatedPage className="sale-order-details" menu={this.props.menu}>
        {action === 'create' && (
          <>
            <h1>{getMessage('order.details.redelivery')}</h1>
            {loading && <Loader />}
            {failed && (
              <div className="retry-message text-muted">
                {getMessage('order.details.errors.onLoad')}
              </div>
            )}
            {saleOrderData && (
              <div className="sale-order-summary-wrapper">
                <ReDeliveryForm
                  saleOrderData={saleOrderData}
                  referenceNumber={referenceNumber}
                />
              </div>
            )}
          </>
        )}
      </AuthenticatedPage>
    )
  }
}

const ReDeliveryPageWrapper = (props) => {
  return <ReDeliveryPage {...props} />
}

export default ReDeliveryPageWrapper
